import { useMap } from 'react-leaflet';
import { LocateControl as LocatePlugin } from 'leaflet.locatecontrol';
import 'leaflet.locatecontrol/dist/L.Control.Locate.min.css';
import { useEffect } from 'react';
import { toast } from 'react-toastify';

const getErrorMessage = (err: any): string => {
  switch (err?.code) {
    case 1:
      return 'Permiso de ubicación denegado';
    case 2:
      return 'No se pudo obtener la ubicación';
    case 3:
      return 'Tiempo de espera agotado al obtener la ubicación';
    default:
      return err?.message || 'Error al obtener la ubicación';
  }
};

const LocateControl: React.FC = () => {
  const map = useMap();

  useEffect(() => {
    const locate = new LocatePlugin({
      position: 'topleft',
      flyTo: true,
      keepCurrentZoomLevel: false,
      showPopup: false,
      locateOptions: { enableHighAccuracy: true },
      strings: {
        title: 'Mostrar mi ubicación',
        text: 'Mostrar mi ubicación',
        metersUnit: 'metros',
        popup: 'Estás a {distance} {unit} de este punto',
        outsideMapBoundsMsg: 'Estás fuera de los límites del mapa',
      },
      onLocationError: (err: any) => {
        toast.error(getErrorMessage(err));
      },
    });

    locate.addTo(map);

    return () => {
      locate.remove();
    };
  }, [map]);

  return null;
};

export default LocateControl;